import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService } from 'src/app/services/category.service';
import { MyCoachService } from 'src/app/services/mycoach.service';
import { CommonService } from 'src/app/services/common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-add-mycoach',
  templateUrl: './add-coach.component.html',
  styleUrls: ['./add-coach.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class AddMyCoachComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  pagetitle: string;
  id: string;
  coachForm: FormGroup;
  coachDesignations: any;
  submitted: boolean = false;
  public countryCodeList: any[] = [];
  public playerId: string = '';

  constructor(
    private categoryService: CategoryService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private myCoachService: MyCoachService,
    private commonService: CommonService
  ) { }

    ngOnInit() {
        this.playerId = this.activatedRoute.snapshot.paramMap.get('playerId');
        this.id = this.activatedRoute.snapshot.paramMap.get('id');
        this.pagetitle = (!this.id) ? 'Add My Coach' : 'Edit My Coach';

        this.coachForm = this.formBuilder.group({
            firstName: [null, [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
            lastName: [null, [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
            phoneCode: [null, [Validators.required]],
            mobileNumber: [null, [Validators.required, Validators.pattern("^[0-9]*$")]],
            designationId: [null, [Validators.required]],
            status: [true] 
        });

        this.getCountryCodes();
        this.getCoachDesignations();

        if (this.id) {
            this.getCoachDetails(this.id);
        }
    }

  get f() {
    return this.coachForm.controls;
  }

  getCoachDesignations() {
    const query = `?filterByParentCategory=coachDesignation`;
    this.categoryService.getCategoryList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.coachDesignations = data?.data?.items;
    });
  }

  getCoachDetails(id: string) {
      this.myCoachService.getMyCoachDetails(id).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.coachForm.patchValue({
              firstName: data.firstName,
              lastName: data.lastName,
              mobileNumber: data.mobileNumber,
              designationId: data.designationId,
              status: data.status
          });
          if (data.phoneCode) {
              const found = this.countryCodeList.find(ele => ele.phone_code === String(data.phoneCode));
              if (found) {
                  this.coachForm.get('phoneCode').setValue(found.phone_code);
              }
          }
      }, err => {
          this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Fetch Coach Details failed!', life: 6000 });
      });
  }

  getCountryCodes() {
    this.commonService.getCountryList().pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.countryCodeList = data.data.items;
        this.setInitialCountryCode();
    });
  }
  setInitialCountryCode() {
    this.coachForm.get('phoneCode').setValue(this.countryCodeList.find(ele => ele.name === 'India')?.phone_code);
  }

  onSubmitCoachForm() {
      this.submitted = true;
      if (this.coachForm.invalid) {
          return;
      }
      const coachFormData = this.coachForm.value;
      coachFormData['status'] = this.coachForm.get('status').value;

      if (!this.id) {
          this.addCoach(coachFormData);
      } else {
          this.updateCoach(this.id, coachFormData);
      }
  }

  addCoach(coachFormData) {
    coachFormData['playerId'] = this.playerId;
    this.myCoachService.addMyCoach(coachFormData).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Coach Added Successfully!', life: 3000 });
      setTimeout(() => {
        this.router.navigate(['/manage/customer/user/my-coach/' + this.playerId]);
      }, 2000);
    }, err => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Coach failed!', life: 6000 });
    });
  }

  updateCoach(id, coachFormData) {
    this.myCoachService.updateMyCoach(id, coachFormData).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Coach Updated Successfully!', life: 3000 });
      setTimeout(() => {
        this.router.navigate(['/manage/customer/user/my-coach/' + this.playerId]);
      }, 2000);
    }, err => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Coach failed!', life: 6000 });
    });
  }

  backLink() {
    this.router.navigate(['/manage/customer/user/my-coach/' + this.playerId]);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}